import { useCallback, useState } from 'react'
import { InputNumberWithLabelMargin, RectangularInputFormatNumberSmall, RectangularInputFormatNumberSmallProps } from '..'
import { getCurrencySymbol } from '../../../utils/globals/price'
import { Modify } from '@teinor/erp'
import useMyDebounce, { MyDebounceProps } from '../../../utils/hooks/useMyDebounce'

export interface InputPriceRectangularProps extends RectangularInputFormatNumberSmallProps {
    CurrencyId: string
}

export const RectangularInputPrice: React.FC<InputPriceRectangularProps> = ({ CurrencyId, className, ...rest }) => {
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    return (
        <div className={'flex items-center rectangular_input_price ' + (className || '')}>
            <RectangularInputFormatNumberSmall {...rest} /> <span className='ml-10'>{CurrencySymbol}</span>
        </div>
    )
}

export type InputPriceStateFullProps = Modify<InputPriceProps, InputPriceStateFullLogicProps & {
    value?: never
}>

export const InputPriceStateFull: React.FC<InputPriceStateFullProps> = ({ onChange, defaultValue, ...rest }) => {
    const { myOnChange, myValue } = useInputPriceStateFullLogic({ onChange, defaultValue, ...rest })
    return (
        <InputPrice  {...rest} value={myValue} onChange={myOnChange} />
    )
}

interface InputPriceStateFullLogicProps {
    defaultValue?: string | number
    onChange: (value: string) => void
}

const useInputPriceStateFullLogic = ({ onChange, defaultValue }: InputPriceStateFullLogicProps) => {
    const [myValue, setMyValue] = useState<string>(String(defaultValue || ''))

    const myOnChange = useCallback((value: string) => {
        setMyValue(value)
        if (onChange) {
            onChange(String(value))
        }
    }, [onChange])
    
    return { myOnChange, myValue }
}


export interface InputPriceProps extends RectangularInputFormatNumberSmallProps {
    CurrencyId: string
    label: string
    subRef?: any
}

const InputPrice: React.FC<InputPriceProps> = ({ CurrencyId, className, ...rest }) => {
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    return (
        <div className={'flex items-end input_price ' + (className || '') }>
            <InputNumberWithLabelMargin {...rest} className='flex-auto w-1' childrenIcon={<span>{CurrencySymbol}</span>} />
        </div>
    )
}

type InputPriceDebounceProps = InputPriceProps & MyDebounceProps & {}

export const InputPriceDebounce: React.FC<InputPriceDebounceProps> = ({ value, onChange, ...inputRest }) => {
    const { changeMyValue, myValue, ref, myOnBlur } = useMyDebounce({ value, onChange, readOnly: inputRest.readOnly })
    return (
        <InputPrice {...inputRest} value={myValue} onChange={changeMyValue} onBlur={myOnBlur} subRef={ref} />
    )
}
export default InputPrice